var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPagePre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    fill: "white",
    stroke: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7842 18.7451L10.89 13.5784L15.6587 8.24081C15.7925 8.10433 15.8657 7.92728 15.864 7.74423C15.8655 7.54898 15.7822 7.36113 15.6323 7.22164C15.5588 7.15225 15.4709 7.0969 15.3737 7.05884C15.2765 7.02079 15.1719 7.00078 15.0662 7C14.9583 7.00199 14.852 7.02347 14.7534 7.06319C14.6547 7.10291 14.5657 7.16008 14.4915 7.23139L9.21509 13.0916C9.07515 13.2309 8.99831 13.4133 9.00003 13.6022C9.00175 13.7911 9.0819 13.9723 9.22436 14.1095L14.6433 19.7734C14.7156 19.8448 14.8034 19.9019 14.9011 19.9409C14.9988 19.9799 15.1043 20 15.2109 20C15.3175 20 15.423 19.9799 15.5207 19.9409C15.6184 19.9019 15.7062 19.8448 15.7785 19.7734C15.9197 19.6336 15.9987 19.4509 16 19.2608C16.0013 19.0708 15.9249 18.8872 15.7856 18.7458",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPagePre);
export default __webpack_public_path__ + "static/media/icon-page-pre.09ed1e75a92d21c2d078e635e23ada0c.svg";
export { ForwardRef as ReactComponent };